<template>
  <div>
    <div style="padding-top: 20px">
      <p class="open-sans-20pt">
        Preverite porabo z mobilno aplikacijo T-2 poraba
      </p>
    </div>
    <div style="padding-top: 20px">
      <p class="navadno-besedilo">
        Aplikacija omogoča spremljanje uporabe storitev T-2 in porabe enot za mobilne in stacionarne
        telefonske številke, podatke o poslanih SMS in MMS sporočilih ter podatke o mobilnem internetnem
        podatkovnem prometu za obdobje zadnjih treh mesecev.
      </p>
    </div>
    <div style="padding-top: 10px" class="flex-container">
      <a :href="t2PorabaTrgovinaPlayPovezava" class="primarna-barva "
         target="_blank">
        <img src="/static/img/T2Aplikacije/Icon-awesome-android.png"
             class="odmik-ikone">
        <span class="odmik-ikona-tekst">
          Trgovina Play
        </span>
      </a>
      <a :href="t2PorabaItunesPovezava" class="primarna-barva levi-odmik"
         target="_blank">
        <img src="/static/img/T2Aplikacije/Icon-awesome-apple.png"
             class="odmik-ikone">
        <span class="odmik-ikona-tekst">
          App Store
        </span>
      </a>
      <el-tooltip class="item primarna-barva" placement="bottom">
        <div slot="content">
          Aplikacijo lahko namestite iz trgovine Huawei AppGallery na <br/>
          mobilnih napravah Huawei.
        </div>
        <a class="primarna-barva levi-odmik">
          <img src="/static/img/T2Aplikacije/Icon-simple-huawei.png"
               class="odmik-ikone">
          <span class="odmik-ikona-tekst">
            Huawei AppGallery
          </span>
        </a>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
import {Tooltip} from 'element-ui'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import ClientAgent from '../../../../../assets/js/clientAgent.js'

export default {
  name: 'KomponentaPorabeTelefonijeAplikacije',
  data () {
    return {
      t2PorabaItunesPovezava: '',
      t2PorabaTrgovinaPlayPovezava: ''
    }
  },
  components: {
    [Tooltip.name]: Tooltip
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.t2PorabaItunesPovezava = povezave.BASE_URL_PORABA_IOS_POVEZAVA
    this.t2PorabaTrgovinaPlayPovezava = povezave.BASE_URL_PORABA_ANDROID_POVEZAVA
  }
}
</script>
<style scoped src="../../../../../../static/css/Poraba/PorabaTelefonija/KomponentaPorabeTelefonijeAplikacije.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelefonija/KomponentaPorabeTelefonijeAplikacije.vue